/** Resolve the attachment URL on a session_image card (frontmatter, body, or path). */

const ATTACHMENT_IMAGE_RE = /\/api\/attachments\/([0-9a-f-]{16,})\/image/i

export function sessionImageSrcFromDocument(doc: {
  frontmatter?: Record<string, unknown> | null
  content?: string | null
  filePath?: string | null
  file_path?: string | null
}): string | null {
  const fm = doc.frontmatter || {}
  const image = String(fm.image || '').trim()
  if (image.startsWith('/api/attachments/') || /^https?:\/\//i.test(image)) return image

  const attachmentId = String(fm.attachment_id || '').trim()
  if (attachmentId) return `/api/attachments/${attachmentId}/image`

  const content = String(doc.content || '')
  const fromBody = content.match(ATTACHMENT_IMAGE_RE)
  if (fromBody?.[1]) return `/api/attachments/${fromBody[1]}/image`

  const path = String(doc.filePath || doc.file_path || '')
  const fromPath = path.match(/\/images\/([^/]+)\.md$/i)
  if (fromPath?.[1]) return `/api/attachments/${fromPath[1]}/image`

  return null
}

export function sessionImageCaptionFromDocument(doc: {
  title?: string | null
  content?: string | null
}): string {
  const content = String(doc.content || '')
  const body = content.replace(/^---[\s\S]*?\n---\s*/, '')
  const bullets = [...body.matchAll(/^\s*-\s+(.+)$/gm)].map((m) => m[1].trim()).filter(Boolean)
  if (bullets.length) return bullets.join(' · ')
  const heading = body.match(/^#\s+(.+)$/m)
  if (heading?.[1]) return heading[1].trim()
  return String(doc.title || 'Session image').trim()
}

/** Ensure markdown preview has a visible image when the pointer lives in frontmatter. */
export function ensureSessionImageMarkdown(
  content: string,
  frontmatter?: Record<string, unknown> | null,
  filePath?: string | null,
): string {
  const src = sessionImageSrcFromDocument({ frontmatter, content, filePath })
  const body = content.replace(/^---[\s\S]*?\n---\s*/, '')
  if (!src) return body
  if (body.includes(src)) return body
  const alt = sessionImageCaptionFromDocument({ content, title: 'Session image' })
  return `![${alt}](${src})\n\n${body}`
}
